/** Map tools that own map clicks and so cannot run together with a Terra Draw mode. */
export const CLICK_TOOLS = ['measure', 'annotate', 'nearest'];

/**
 * Decide what to do when the active tool / draw mode changes.
 * prev / cur: { tool, drawMode }. Returns 'exitDraw' (a tool was just activated),
 * 'clearTool' (a draw mode was just activated) or null.
 */
export function exclusiveAction(prev, cur) {
  const toolOn = CLICK_TOOLS.includes(cur.tool);
  if (!toolOn || !cur.drawMode) return null;
  if (cur.tool !== prev.tool) return 'exitDraw';
  if (cur.drawMode !== prev.drawMode) return 'clearTool';
  return null;
}
